<form [formGroup]="parentForm()" ngNativeValidate>
  <div class="form-wrapper input-wrapper">
    <div class="toggle">
      <mat-slide-toggle formControlName="isEnabled">
        <span class="label"><span>{{label()}}</span> is
                      @if (parentForm().get('isEnabled')?.value === true) {
                        Enabled
                      } @else {
                        Disabled
                      }</span>
      </mat-slide-toggle>
      <mat-hint class="hint">Sets whether the {{label()}} is enabled or disabled for use.</mat-hint>
    </div>

    <div class="toggle">
      <mat-slide-toggle formControlName="isUniversal">
                    <span class="label"><span>{{label()}}</span>
                      @if (parentForm().get('isUniversal')?.value === true) {
                        set to Universal
                      } @else {
                        is not Universal
                      }</span>
      </mat-slide-toggle>
      <mat-hint class="hint">Bypasses the security check and makes it available to use for everyone. The
        "owners"
        permissions stand. It ignores the Granted Users and let's everyone use it. </mat-hint>
    </div>
  </div>
</form>
